module.exports = __webpack_public_path__ + "img/Princessed.41193cf8.jpg";